import { action, makeObservable, observable } from 'mobx';

class RoundTimeStore {
  time = null;

  passedSeconds = null;

  constructor() {
    makeObservable(this, {
      time: observable,
      passedSeconds: observable,
      setTime: action.bound,
      setPassedSeconds: action.bound,
      resetRoundTimeData: action.bound,
    });
  }

  setTime(time) {
    this.time = time;
  }

  setPassedSeconds(second) {
    this.passedSeconds = second;
  }

  resetRoundTimeData() {
    this.time = null;
    this.passedSeconds = null;
  }
}

export const roundTimeStore = new RoundTimeStore();
